import * as styles from './styles.module.scss';

const NoOrders = () => (
  <div className={styles.noOrders} data-testid="no-orders-container">
    <i className="fal fa-box-open" data-testid="no-orders-icon" />
    <h2>No Orders Placed Yet</h2>
    <p>Treat yourself and start shopping!</p>
  </div>
);

export default NoOrders;
